import React, { useState } from 'react';

function WhyJoinSky47Section({ data }) {

    // Sort why_join_sky47_grid by grid_order_number
    const sortedGridItems = data?.why_join_sky47_grid
        ? [...data.why_join_sky47_grid].sort((a, b) => {
            const orderA = a.grid_order_number || 9999;
            const orderB = b.grid_order_number || 9999;
            return orderA - orderB;
        })
        : [];

    return (
        <div className="what_we_stand_for sky47-join-wrapper">
            <div className="what_we_stand_for_container">
                <div className="content-header">
                    <h1 className="main-heading">Why Join Sky47?</h1>
                </div>
                <div className="cards-container">
                    {sortedGridItems.map((item, idx) => (
                        <div className="service-card" key={item.grid_order_number || idx}>
                            <div className="frame-group-wrapper">
                                <div className="frame-group">
                                    <div className="frame-ellipse"></div>
                                    <div className="frame-div"></div>
                                    <div className="frame-ellipse-2"></div>
                                </div>
                            </div>
                            <img
                                src={item.grid_icon_url}
                                className="card-icon"
                                alt="card-icon"
                            />
                            <h3 className="card-title">{item.grid_heading}</h3>
                            <p className="card-description">{item.gird_paragraph}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default WhyJoinSky47Section;